document.addEventListener("DOMContentLoaded", function () {

    const swiperIndexNews = new Swiper('.JS-index-news', {
        speed: 400,
        spaceBetween: 20,
        slidesPerView: 1.2,
        navigation: {
            nextEl: '.swiper-button-next',
        },
        simulateTouch: true,
        touchRatio: 1,
        grabCursor: true,
        autoplay: false,
        breakpoints: {
            1024: {
                slidesPerView: 1.5,
                spaceBetween: 30,
            },
            1600: {
                slidesPerView: 2.5,
                spaceBetween: 40,
            }
        },
    });

    const swiperIndexNewsMobile = new Swiper('.JS-index-news-mobile', {
        speed: 400,
        spaceBetween: 20,
        slidesPerView: 1.2,
        navigation: {
            nextEl: '.swiper-button-next',
        },
        simulateTouch: true,
        touchRatio: 1,
        grabCursor: true,
        autoplay: false,
    });
});
